import { DestroyRef, Directive, ElementRef, inject, input } from '@angular/core';
import { Modal } from '@spirit-testing/component-library';

export type ModalCloseOrigin = 'backdrop' | 'other';

// lib-modal blendet sich in onClose immer aus, auch wenn der Aufrufer nicht schliessen will, und
// meldet Hintergrund, X, Esc und Abbrechen gleich. Wieder einblenden wuerde den Fokus aus dem Dialog
// reissen und die Scroll-Sperre loesen, deshalb faellt die Entscheidung vorher.
// Entfaellt, sobald lib-modal das selbst kann.
@Directive({
  selector: 'lib-modal[appModalCloseGuard]',
})
export class ModalCloseGuardDirective {
  readonly canClose = input.required<(origin: ModalCloseOrigin) => boolean>({ alias: 'appModalCloseGuard' });

  constructor() {
    const host = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
    const modal = inject(Modal, { self: true });
    let clickOnBackdrop = false;

    const remember = (event: Event) => {
      clickOnBackdrop = event.target instanceof Element && event.target.classList.contains('modal__backdrop');
    };
    host.addEventListener('click', remember, true);
    inject(DestroyRef).onDestroy(() => host.removeEventListener('click', remember, true));

    const close = modal.onClose.bind(modal);
    modal.onClose = () => {
      const origin = clickOnBackdrop ? 'backdrop' : 'other';
      clickOnBackdrop = false;
      if (this.canClose()(origin)) {
        close();
      }
    };
  }
}
